import React from "react";
import styled from "styled-components";
import { ErrorText } from "./basics";

const Container = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-height: 50px;
`;

export default function ErrorContent({ text }) {
  return (
    <Container>
      <ErrorText>{text}</ErrorText>
    </Container>
  );
}
